var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnlock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14128_59905)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 1C11.916 1.02623 10.8866 1.48077 10.137 2.26414C9.38734 3.04752 8.97853 4.09594 9 5.18V7.5H1V16C1 16.2652 1.10536 16.5196 1.29289 16.7071C1.48043 16.8946 1.73478 17 2 17H11C11.2652 17 11.5196 16.8946 11.7071 16.7071C11.8946 16.5196 12 16.2652 12 16V7.5H10V5.18C9.97844 4.36112 10.2819 3.56699 10.844 2.97114C11.4061 2.37528 12.1813 2.02614 13 2C13.8187 2.02614 14.5939 2.37528 15.156 2.97114C15.7181 3.56699 16.0216 4.36112 16 5.18V8.595C16 8.72761 16.0527 8.85478 16.1464 8.94855C16.2402 9.04232 16.3674 9.095 16.5 9.095C16.6326 9.095 16.7598 9.04232 16.8536 8.94855C16.9473 8.85478 17 8.72761 17 8.595V5.18C17.0215 4.09594 16.6127 3.04752 15.863 2.26414C15.1134 1.48077 14.084 1.02623 13 1ZM7 12.615V14H6V12.57C5.75657 12.4447 5.56329 12.24 5.45222 11.9898C5.34116 11.7396 5.31899 11.4589 5.38939 11.1944C5.45979 10.9298 5.61853 10.6973 5.83928 10.5354C6.06002 10.3734 6.32949 10.2919 6.60297 10.3042C6.87646 10.3165 7.13751 10.4219 7.34282 10.603C7.54813 10.7841 7.68534 11.03 7.7317 11.2998C7.77806 11.5696 7.73076 11.8471 7.59767 12.0864C7.46458 12.3256 7.25369 12.5121 7 12.615Z",
    fill: "#666666"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14128_59905"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "static/media/unlock.cf7e3c25.svg";
export { ForwardRef as ReactComponent };